import {
    WHITEBOARD_PAGE_CLEAR,
    WHITEBOARD_PAGE_FETCH,
    WHITEBOARD_PAGE_FETCH_COMPLETED,
    WHITEBOARD_PAGE_MOVE,
    WHITEBOARD_PAGE_REMOVE,
    WHITEBOARD_PAGES_CREATE,
} from "constants/action-types";
import { EventTypes } from "redux-segment";

export const fetchById = (pageId, meta = {}) => ({
    meta,
    payload: pageId,
    type: WHITEBOARD_PAGE_FETCH,
});

export const move = (oldIndex, newIndex) => ({
    meta: {
        analytics: EventTypes.track,
    },
    payload: {
        destination_index: newIndex,
        index: oldIndex,
    },
    type: WHITEBOARD_PAGE_MOVE,
});
/*
export const mutate = (index, props) => {
    return (dispatch, getState) => {
        const state = getState();
        const { pages } = state.whiteboard;
        const page = pages.get(index);

        dispatch({
            payload: pages.set(index, {...page, ...props}),
            type: WHITEBOARD_PAGES_MUTATE,
        });
    };
};
*/
export const add = () => ({
    meta: {
        analytics: EventTypes.track,
    },
    type: WHITEBOARD_PAGES_CREATE,
});

export const remove = (index: number, id: string) => ({
    meta: {
        analytics: EventTypes.track,
    },
    payload: { index, id },
    type: WHITEBOARD_PAGE_REMOVE,
});

export const current = {
    set: (id: string, meta?) => fetchById(id, meta),
};

export const pageHistoryFetch = (historyState, pageId) => ({
    meta: historyState,
    payload: pageId,
    type: WHITEBOARD_PAGE_FETCH,
});

export const pageHistoryFetchComplete = ({ meta, payload }) => ({
    meta,
    payload,
    type: WHITEBOARD_PAGE_FETCH_COMPLETED,
});

export const clear = () => ({ type: WHITEBOARD_PAGE_CLEAR });
